const groupA = [
	'Code Key',
	'Star Sign',
	'Weak or Strong'
]

const groupB = [
	'Code Key',
	'Star Sign',
	'Weak or Strong'
]

const groupC = [
	'Code Key',
	'Star Sign',
	'Weak or Strong'
]

const groupD = [
	'Code Key',
	'Star Sign',
	'Weak or Strong'
]

const groupE = [
	'Code Key',
	'Star Sign',
	'Weak or Strong'
]

const groupF = [
	'Code Key',
	'Star Sign',
	'Weak or Strong'
]

const groupG = [
	'Code Key',
	'Star Sign',
	'Weak or Strong'
]

const groupH = [
	'Code Key',
	'Star Sign',
	'Weak or Strong'
]

const groupI = [
	'Code Key',
	'Star Sign',
	'Weak or Strong'
]

export default {
	groupA,
	groupB,
	groupC,
	groupD,
	groupE,
	groupF,
	groupG,
	groupH,
	groupI
}